import useScopedTranslation from 'hooks/useScopedTranslation';
import { cardStatsI18n } from './i18n';

const CardStats = ({
  DesignSystemComponents,
  title,
  count = 0,
  priorityCount = 0,
  subtitle,
  icon,
  loading = false,
  type = 'info',
  fill,
  size,
}) => {
  const { Card, SvgIcon, Skeleton } = DesignSystemComponents;
  const { t } = useScopedTranslation(cardStatsI18n);
  const resolvedTitle = title || t('cardStats_noInfo');
  const resolvedSubtitle = subtitle || t('cardStats_noInfo');

  const colorMap = {
    success: 'var(--success-500)',
    warning: 'var(--warning-500)',
    error: 'var(--error-500)',
    cancel: 'var(--font-light)',
  };

  const color = colorMap[type] ?? 'var(--primary-500)';

  return (
    <Card specialPadding='p-4'>
      <div className='d-flex align-items-center justify-content-between'>
        <div>
          <p className='caption fw-normal font-light'>{resolvedTitle}</p>

          <h2 className='fw-semibold  d-flex align-items-center gap-2'>
            {loading ? (
              <Skeleton height='2.25rem' width='2rem' />
            ) : priorityCount > 0 ? (
              <>
                {count} <span>|</span>
                <span className='priority-high'>{priorityCount}</span>
                <SvgIcon
                  className='priority-icon'
                  name='exclamationTriangle'
                  size={size ? size : '1.25rem'}
                  fill='var(--error-500)'
                />
              </>
            ) : (
              `${count}`
            )}
          </h2>

          <p className='mini fw-normal font-light'>{resolvedSubtitle}</p>
        </div>

        {icon && (
          <SvgIcon
            {...(fill ? { fill: color } : { stroke: color })}
            name={icon}
            size={size ? size : '1.25rem'}
          />
        )}
      </div>
    </Card>
  );
};

export default CardStats;
